import { useCoinUserEvents } from 'business-logic/tracking'
import { useAsyncEffect } from 'app-logic/react/useAsyncEffect'

interface RedirectEmptyPageProps {
  path?: string
}
export const RedirectEmptyPage: React.FC<RedirectEmptyPageProps> = ({ path }) => {
  const userEvents = useCoinUserEvents()
  useAsyncEffect(async() => {

    await userEvents.customEvent('NoOfferFound404', { href: window.location.href })
    const protocol = window.location.protocol
    const domain = window.location.host.replace('3001', '3000')
    const upath = path ?? window.location.pathname.replace('/free/', '/free-nfc/')
    const search = window.location.search
    const destination = `${protocol}//${domain}${upath}/${search}`
    window.location.href = destination
  }, [ userEvents ])
  return (
    <div></div>
  )
}